// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/fonts/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/fonts/Gilroy-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/fonts/Gilroy-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../assets/fonts/Gilroy-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "bold-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "bold-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "semi-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "semi-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "med-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "bold-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: "extra-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: "semi-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.Navigation_navigation__3Zhcz {
  width: 100%;
  height: 61px;
  background-color: var(--sb-bg-color);
  border: 1px solid var(--sb-border-color);
  display: flex;
  padding: 15px 24px;
}
.Navigation_navigation__3Zhcz span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.Navigation_navigation__3Zhcz img {
  width: 51px;
  height: 36px;
  display: block;
}
.Navigation_navigation__3Zhcz .Navigation_logoText__Pghs8 {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
  margin-left: 3px;
}
.Navigation_navigation__3Zhcz .Navigation_toggle__eLKdk {
  width: 30px;
  height: 30px;
  margin-left: auto;
}
@media (max-width: 781px) {
  .Navigation_navigation__3Zhcz span {
    display: none;
  }
}
@media (min-width: 781px) {
  .Navigation_navigation__3Zhcz img, .Navigation_navigation__3Zhcz .Navigation_logoText__Pghs8 {
    display: none;
  }
}

@media (max-width: 781px) {
  .Navigation_navigation__3Zhcz {
    height: 64px;
    padding: 14px 17px 14px 21px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/_variables.scss","webpack://./src/components/Layouts/DashboardLayout/Navigation/Navigation.module.scss"],"names":[],"mappings":"AA4CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,8BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,8BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,6BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,yBAAA;EACA,4CAAA;AC3CF;AApCA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,wCAAA;EACA,aAAA;EACA,kBAAA;AAsCF;AApCE;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAsCJ;AAnCE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAqCJ;AAlCE;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAoCJ;AAjCE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAmCJ;AAhCE;EACE;IACE,aAAA;EAkCJ;AACF;AA/BE;EACE;IACE,aAAA;EAiCJ;AACF;;AA7BA;EACE;IACE,YAAA;IACA,4BAAA;EAgCF;AACF","sourcesContent":["// colors\n$primary-color: #5d2de1;\n$dark-color: #141029;\n$cultured-color: #f5f7fa;\n$dark-text-color: rgba(20, 16, 41, 0.8);\n$white-color: #ffffff;\n$card-gradient-color: linear-gradient(\n  135deg,\n  #ffffff 0%,\n  #fafbfc 51.82%,\n  #f5f7fa 100%\n);\n$pink-color: #e0e0ff;\n$white-color-40: rgba(255, 255, 255, 0.4);\n$white-color-4: rgba(224, 224, 255, 0.04);\n$danger-color: #f54562;\n\n// fonts\n\n$font-size-xs: 13px;\n$font-size-sm: 14px;\n$font-size-md: 16px;\n$font-size-xm: 18px;\n$font-size-lg: 20px;\n$font-size-xl: 24px;\n$font-size-xxl: 30px;\n$font-size-3xl: 36px;\n$font-size-4xl: 48px;\n\n$font-height-xs: 16px;\n$font-height-sm: 20px;\n$font-height-md: 24px;\n$font-height-xm: 28px;\n$font-height-lg: 30px;\n$font-height-xl: 32px;\n$font-height-xxl: 36px;\n$font-height-3xl: 40px;\n$font-height-4xl: 48px;\n\n$font-light: 500;\n$font-med: 600;\n$font-bold: 700;\n$font-extra: 800;\n\n@font-face {\n  font-family: \"bold-Poppins\";\n  src: url(/assets/fonts/Poppins-Bold.ttf);\n}\n@font-face {\n  font-family: \"bold-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Bold.ttf);\n}\n@font-face {\n  font-family: \"semi-Poppins\";\n  src: url(/assets/fonts/Poppins-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"semi-Montserrat\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-Poppins\";\n  src: url(/assets/fonts/Poppins-Medium.ttf);\n}\n@font-face {\n  font-family: \"med-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Medium.ttf);\n}\n@font-face {\n  font-family: \"bold-gilory\";\n  src: url(/assets/fonts/Gilroy-Bold.ttf);\n}\n@font-face {\n  font-family: \"extra-gilory\";\n  src: url(/assets/fonts/Gilroy-ExtraBold.otf);\n}\n@font-face {\n  font-family: \"semi-gilory\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-gilory\";\n  src: url(/assets/fonts/Gilroy-Medium.ttf);\n}\n\n$title-font-family-bold: \"bold-Poppins\";\n$title-font-family-semi: \"semi-Poppins\";\n$title-font-family-med: \"med-Poppins\";\n$text-font-family-bold: \"bold-Montserrat\";\n$text-font-family-semi: \"semi-Montserrat\";\n$text-font-family-med: \"med-Montserrat\";\n$number-font-family-bold: \"bold-gilory\";\n$number-font-family-extra: \"extra-gilory\";\n$number-font-family-semi: \"semi-gilory\";\n$number-font-family-med: \"med-gilory\";\n\n// dark and light theme\n$dark-bg-color: #111315; // background\n$dark-sb-bg-color: #242527; // sidebar\n\n$light-bg-color: #F4F4F4; // background\n$light-sb-bg-color: #FCFCFC; // sidebar","@import \"/src/assets/stylesheets/variables\";\n\n\n.navigation {\n  width: 100%;\n  height: 61px;\n  background-color: var(--sb-bg-color);\n  border: 1px solid var(--sb-border-color);\n  display: flex;\n  padding: 15px 24px;\n\n  span {\n    color: var(--font-color);\n    font-family: Red Hat Display;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n\n  img {\n    width: 51px;\n    height: 36px;\n    display: block;\n  }\n\n  .logoText {\n    color: var(--font-color);\n    font-family: Red Hat Display;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 44px;\n    margin-left: 3px;\n  }\n\n  .toggle {\n    width: 30px;\n    height: 30px;\n    margin-left: auto;\n  }\n\n  @media (max-width: 781px) {\n    span {\n      display: none;\n    }\n  }\n\n  @media (min-width: 781px) {\n    img, .logoText {\n      display: none;\n    }\n  }\n}\n\n@media (max-width: 781px) {\n  .navigation {\n    height: 64px;\n    padding: 14px 17px 14px 21px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigation": `Navigation_navigation__3Zhcz`,
	"logoText": `Navigation_logoText__Pghs8`,
	"toggle": `Navigation_toggle__eLKdk`
};
export default ___CSS_LOADER_EXPORT___;
